export enum RegexTypeEnum {
    /** 税号 */
    TIN = 'TIN',
    /** 拉丁字符姓名 */
    LATIN_NAME = 'LATIN_NAME'
}

export interface CheckRegexResponse {
    regex_type: RegexTypeEnum;
    /** 字段值 */
    text: string;
    passed: boolean;
}
